import CloseIcon from '@mui/icons-material/Close'
import { FC, ReactNode } from 'react'

import * as Styled from './styles'

type Props = {
  isOpen: boolean
  onClose?: () => void
  children: ReactNode
  width?: string
  borderRadius?: string
  height?: string
  showCloseIcon?: boolean
  closeOnOutsideClick?: boolean
}

const Modal: FC<Props> = ({
  children,
  isOpen,
  onClose,
  width,
  height,
  borderRadius,
  showCloseIcon,
  closeOnOutsideClick = true,
}) => (
  <>
    <Styled.Overlay isVisible={isOpen} onClick={closeOnOutsideClick ? onClose : undefined} />
    <Styled.ModalContainer
      isVisible={isOpen}
      width={width}
      height={height}
      borderRadius={borderRadius}
    >
      {showCloseIcon && onClose && (
        <Styled.CloseIcon onClick={onClose} title='Close' aria-label='Close'>
          <CloseIcon fontSize='small' />
        </Styled.CloseIcon>
      )}
      {children}
    </Styled.ModalContainer>
  </>
)

export default Modal
